import script from "./ProjectBudget.vue?vue&type=script&setup=true&lang=js"
export * from "./ProjectBudget.vue?vue&type=script&setup=true&lang=js"

import "./ProjectBudget.vue?vue&type=style&index=0&id=6e0c7e1d&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6e0c7e1d"]])

export default __exports__